import { AdminReports } from './AdminReports';

export default AdminReports;